import { z } from "zod";
import { stripSearchParams, type SearchMiddleware } from "@tanstack/react-router";
import {
  defaultPageSearch,
  optionalCalendarDay,
  optionalPage,
  optionalSearch,
} from "./shared";

const merchantSortSchema = z.enum([
  "createdAt:asc",
  "createdAt:desc",
  "name:asc",
  "name:desc",
]);

export const merchantsSearchDefaults = {
  ...defaultPageSearch,
  sort: "createdAt:desc" as const,
};

export const merchantsSearchSchema = z.object({
  nameContains: optionalSearch(z.string()),
  createdAfter: optionalCalendarDay,
  createdBefore: optionalCalendarDay,
  sort: optionalSearch(merchantSortSchema),
  page: optionalPage,
});

export type MerchantsSearch = z.infer<typeof merchantsSearchSchema>;

export const merchantsSearchMiddlewares: SearchMiddleware<MerchantsSearch>[] = [
  stripSearchParams(merchantsSearchDefaults) as SearchMiddleware<MerchantsSearch>,
];
